import axios from 'axios';
import CryptoJS from 'crypto-js';
import { btoa, atob } from '../../lib/helpers';

const logSpeFee = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      loading: false,
      cacheData: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      totalPage: 0,
    };
  },

  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    clearErrorVariable(state, variable) {
      state.errors[variable] = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    removeSingleData(state, { index }) {
      state.totalData -= 1;
      state.allData = state.allData.filter((value) => value.mcc != index);
    },

    addData(state) {
      state.totalData += 1;
    },

    pushData(state, { payload }) {
      state.allData.push(payload);
    },

    editData(state, { payload, index }) {
      Object.assign(state.allData[index], payload);
    },
  },

  actions: {
    async getData(ctx, { date, page, itemsPerPage, sortBy, sortDesc, search }) {
      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      const sort_by = `${sortBy[0] ? sortBy[0] : 'mcc'} ${sort}`;

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/setting-fee/fee-spe/change-log`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };

      const doGetOut = () => ctx.dispatch('logout', null, { root: true });

      await axios(config)
        .then((response) => {
          if (response.data.code != 200) {
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }

            if (response.data.code == '401') doGetOut();
          } else {
            ctx.commit('setTotalData', { payload: response.data });
            ctx.commit('setData', { payload: response.data });
          }
        })
        .catch((err) => {
          if (err.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: err.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (err.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
        });

      ctx.commit('setLoading', false);
    },
  },
};

export default logSpeFee;
